<template>
    <div class="table_with_container">
        <div class="search_cont">
            <el-form
                :inline="true"
                :model="searchForm"
                class="leader-style-form leader-form-inner-tab-inline"
            >
                <el-form-item label="时间" style="float: left">
                    <el-date-picker
                        v-model="time"
                        align="right"
                        type="date"
                        :clearable="false"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        @change="handleTimeChange"
                        v-show="tabVal === 'day' || tabVal === 'port'"
                    ></el-date-picker>
                    <el-date-picker
                        v-model="time"
                        type="month"
                        :clearable="false"
                        placeholder="选择月"
                        value-format="yyyy-MM"
                        :picker-options="pickerOptions"
                        @change="handleTimeChange"
                        v-show="tabVal === 'month'"
                    ></el-date-picker>
                    <el-date-picker
                        v-model="time"
                        type="year"
                        placeholder="选择年"
                        format="yyyy"
                        value-format="yyyy"
                        :clearable="false"
                        :picker-options="pickerOptions"
                        @change="handleTimeChange"
                        v-show="tabVal === 'year'"
                    ></el-date-picker>
                    <el-button
                        size="small"
                        @click="forwardTimeClick"
                        style="margin-left: 10px"
                    >
                        上一{{
                            tabVal == "port"
                                ? "日"
                                : tabVal === "day"
                                ? "日"
                                : tabVal === "month"
                                ? "月"
                                : "年"
                        }}
                    </el-button>
                    <el-button
                        size="small"
                        :disabled="nextTimeDisabled"
                        @click="nextTimeClick"
                    >
                        下一{{
                            tabVal == "port"
                                ? "日"
                                : tabVal === "day"
                                ? "日"
                                : tabVal === "month"
                                ? "月"
                                : "年"
                        }}
                        <!-- <i class="el-icon-caret-right"></i> -->
                    </el-button>
                    <el-label
                        style="
                            color: #fff;
                            font-size: 0.8rem;
                            margin-left: 20px;
                        "
                        v-show="!isKW"
                        >合计电量:{{ sum_active_power }}kW·h</el-label
                    >
                </el-form-item>
                <div style="text-align: end">
                    <template v-if="tabVal != 'port'">
                        <el-button
                            class="active-table-data"
                            v-show="isTable"
                            type="primary"
                            size="small"
                            @click="changeTableOrChart(false)"
                            >数据</el-button
                        >
                        <el-button
                            class="active-table"
                            v-show="!isTable"
                            type="primary"
                            size="small"
                            @click="changeTableOrChart(true)"
                            >图表</el-button
                        >
                    </template>

                    <el-button
                        type="primary"
                        size="small"
                        @click="handleSearchReport"
                        >查询</el-button
                    >
                    <!-- <el-button
                        type="primary"
                        size="small"
                        @click="handleExportExl"
                        v-if="tabVal != 'port'"
                        v-pms="'btn_power_report_import'"
                        >导出</el-button
                    > -->
                </div>
            </el-form>
        </div>
        <div class="table_cont-wrap">
            <div class="leader-title" style="margin: 0 0 20px 0" v-if="isKW">
                {{
                    tabVal === "port"
                        ? "实时负荷(单位:kW)"
                        : tabVal === "day"
                        ? "日报(单位:kW)"
                        : tabVal === "month"
                        ? "月报(单位:kW)"
                        : "年报(单位:kW)"
                }}
            </div>
            <div class="leader-title" style="margin: 0 0 20px 0" v-else>
                {{
                    tabVal === "port"
                        ? "实时负荷(单位:kW)"
                        : tabVal === "day"
                        ? "日报(单位:kW·h)"
                        : tabVal === "month"
                        ? "月报(单位:kW·h)"
                        : "年报(单位:kW·h)"
                }}
            </div>
            <div class="table_change_btn" v-if="tabVal != 'port'">
                <el-button
                    :class="[isKW ? 'active-table' : 'active-table-data']"
                    type="primary"
                    size="small"
                    @click="changeKWOrKWH(true)"
                    >功率</el-button
                >
                <el-button
                    :class="[isKW ? 'active-table-data' : 'active-table']"
                    type="primary"
                    size="small"
                    @click="changeKWOrKWH(false)"
                    >电量</el-button
                >
            </div>
            <div class="table-wrap-n" v-loading="tableLoading" v-if="isKW">
                <template v-if="isTable">
                    <el-table
                        class="leader-style-table"
                        :data="tableData"
                        height="100%"
                        style="width: 100%"
                    >
                        <el-table-column
                            prop="name"
                            label="采集点"
                        ></el-table-column>
                        <el-table-column label="时间">
                            <template slot-scope="scope">
                                <span v-if="tabVal == 'day'"
                                    >{{ scope.row.show_day }}时</span
                                >
                                <span v-else-if="tabVal == 'month'"
                                    >{{ scope.row.show_day }}日</span
                                >
                                <span v-else-if="tabVal == 'year'"
                                    >{{ scope.row.show_day }}月</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column prop="active_power" label="功率（kW）">
                        </el-table-column>
                    </el-table>
                </template>
                <template v-else>
                    <v-chart
                        :auto-resize="true"
                        :options="lineBar"
                        ref="lineBar"
                        theme="ovilia-green"
                    />
                </template>
            </div>
            <div class="table-wrap-n" v-loading="tableHLoading" v-else>
                <template v-if="isTable">
                    <el-table
                        class="leader-style-table"
                        :data="tableHData"
                        height="100%"
                        style="width: 100%"
                    >
                        <el-table-column
                            prop="name"
                            label="采集点"
                        ></el-table-column>
                        <el-table-column label="时间">
                            <template slot-scope="scope">
                                <span v-if="tabVal == 'day'"
                                    >{{ scope.row.show_day }}时</span
                                >
                                <span v-else-if="tabVal == 'month'"
                                    >{{ scope.row.show_day }}日</span
                                >
                                <span v-else-if="tabVal == 'year'"
                                    >{{ scope.row.show_day }}月</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="active_power"
                            label="电量（kW·h）"
                        >
                        </el-table-column>
                    </el-table>
                </template>
                <template v-else>
                    <v-chart
                        :auto-resize="true"
                        :options="lineHBar"
                        ref="lineHBar"
                        theme="ovilia-green"
                    />
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
// import moment from "moment";
import dayjs from "dayjs";
import * as api from "@/http/api.js";
export default {
    components: {},
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            time: "",
            checkStrictly: true,
            nextTimeDisabled: false,
            tableData: [],
            tableHData: [],
            tableLoading: false,
            tableHLoading: false,
            isTable: false,
            isKW: true,
            xAxis: [],
            yAxis: [],
            xHAxis: [],
            yHAxis: [],
            todayY: "",
            todayM: "",
            todayD: "",
            sum_active_power: "",
            systemDate: ""
        };
    },
    props: {
        curTab: {
            type: String,
            default: ""
        },
        tabVal: {
            type: String,
            default: "port"
        },
        curPointId: {
            type: String,
            default: ""
        },
        pointName: {
            type: String,
            default: ""
        }
    },
    created() {
        this.getSysDate("day");
        this.todayY = this.getTimeValue("year");
        this.todayM = this.getTimeValue("month");
        this.todayD = this.getTimeValue("day");
        this.nextTimeDisabled = true;
    },
    watch: {
        tabVal(newVal, oldVal) {
            if (newVal != oldVal && this.curTab == "1") {
                this.nextTimeDisabled = true;
                if (newVal == "port") {
                    this.time = this.systemDate.sysdate;
                    this.getPortData();
                } else if (newVal == "day") {
                    this.time = this.systemDate.sysdate;
                    this.getDayData();
                }
                if (newVal == "month") {
                    this.time = this.systemDate.sysdate3;
                    this.getMonthData();
                }
                if (newVal == "year") {
                    this.time = this.systemDate.sysdate4;
                    this.getYearData();
                }
            }
        },
        curPointId(newVal, oldVal) {
            if (newVal != oldVal && this.curTab == "1") {
                if (this.tabVal == "port") this.getPortData();
                if (this.tabVal == "day") this.getDayData();
                if (this.tabVal == "month") this.getMonthData();
                if (this.tabVal == "year") this.getYearData();
            }
        }
    },
    methods: {
        /**
         * 获取系统时间
         */
        getSysDate(type) {
            api.getSysDate1().then(res => {
                if (res && res.error_code === "0") {
                    this.systemDate = res.bus_json;
                    this.time = res.bus_json.sysdate;
                }
            });
        },
        /**
         * 日期改变回调函数
         */
        handleTimeChange(val) {
            let toDay = new Date(this.toDay).getTime();
            let selectTime = new Date(val).getTime();
            if (selectTime >= toDay) {
                this.nextTimeDisabled = true;
            } else {
                this.nextTimeDisabled = false;
            }
        },
        /**
         * 上一日、上一月、上一年点击
         */
        forwardTimeClick() {
            this.nextTimeDisabled = false;
            if (this.tabVal === "day" || this.tabVal === "port") {
                this.time = dayjs(new Date(this.time))
                    .subtract(1, "days")
                    .format("YYYY-MM-DD");
            } else if (this.tabVal === "month") {
                this.time = dayjs(new Date(this.time))
                    .subtract(1, "months")
                    .format("YYYY-MM");
            } else {
                this.time = dayjs(new Date(this.time))
                    .subtract(1, "years")
                    .format("YYYY");
            }
            // 获取报告列表
            this.handleSearchReport();
        },
        changeTableOrChart(isTable) {
            this.isTable = isTable;
        },
        changeKWOrKWH(isKW) {
            this.isKW = isKW;
        },
        /**
         * 获取时间值
         * params{type<string>} type = day(日) type = month(月) type = year(年)
         */
        getTimeValue(type) {
            let date = new Date();
            if (type === "year") {
                return date.getFullYear() + "";
            } else if (type === "month") {
                return date.getFullYear() + "-" + (date.getMonth() + 1);
            } else {
                return (
                    date.getFullYear() +
                    "-" +
                    (date.getMonth() + 1) +
                    "-" +
                    date.getDate()
                );
            }
        },
        /**
         * 选择搜索
         */
        handleSearchReport() {
            if (this.tabVal === "port") {
                this.getPortData();
            } else if (this.tabVal === "day") {
                this.getDayData();
            } else if (this.tabVal === "month") {
                this.getMonthData();
            } else {
                this.getYearData();
            }
        },
        //获取关口数据
        getPortData() {
            this.tableLoading = true;
            api.getIncomeLineP({
                tree_unit_id: this.curPointId,
                show_day: this.formatShowDay()
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.tableLoading = false;
                    this.xAxis = res.bus_json.x_list;
                    this.yAxis = res.bus_json.ps_list;
                }
            });
        },
        /**
         * 获取日报列表
         */
        getDayData() {
            let params = {};
            if (!this.curPointId) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            params = {
                tree_unit_id: this.curPointId,
                show_day: this.formatShowDay()
            };
            this.tableLoading = true;
            api.getDayDataForReport(params).then(res => {
                if (res && res.error_code === "0") {
                    this.xAxis = [];
                    this.yAxis = [];
                    if (res.bus_json.length) {
                        res.bus_json.forEach(item => {
                            item.name = this.pointName;
                            this.xAxis.push(item.show_day);
                            this.yAxis.push(item.active_power);
                        });
                    }
                    this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            });
            this.tableHLoading = true;
            api.getDayDataCollection(params).then(res => {
                if (res && res.error_code === "0") {
                    this.xHAxis = [];
                    this.yHAxis = [];
                    if (res.bus_json.powerReportList.length) {
                        res.bus_json.powerReportList.forEach(item => {
                            item.name = this.pointName;
                            this.xHAxis.push(item.show_day);
                            this.yHAxis.push(item.active_power);
                        });
                    }
                    this.sum_active_power = res.bus_json.sum_active_power;
                    this.tableHData = res.bus_json.powerReportList;
                }
                this.tableHLoading = false;
            });
        },
        /**
         * 获取月报列表
         */
        getMonthData() {
            let params = {};
            if (!this.curPointId) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            this.tableLoading = true;
            params = {
                tree_unit_id: this.curPointId,
                show_day: this.formatShowDay()
            };
            api.getMonthDataForReport(params).then(res => {
                if (res && res.error_code === "0") {
                    this.xAxis = [];
                    this.yAxis = [];
                    if (res.bus_json.length) {
                        res.bus_json.forEach(item => {
                            item.name = this.pointName;
                            this.xAxis.push(item.show_day);
                            this.yAxis.push(item.active_power);
                        });
                    }
                    this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            });
            this.tableHLoading = true;
            api.getMonthDataCollection(params).then(res => {
                if (res && res.error_code === "0") {
                    this.xHAxis = [];
                    this.yHAxis = [];
                    if (res.bus_json.powerReportList.length) {
                        res.bus_json.powerReportList.forEach(item => {
                            item.name = this.pointName;
                            this.xHAxis.push(item.show_day);
                            this.yHAxis.push(item.active_power);
                        });
                    }
                    this.sum_active_power = res.bus_json.sum_active_power;
                    this.tableHData = res.bus_json.powerReportList;
                }
                this.tableHLoading = false;
            });
        },
        /**
         * 获取年报列表
         */
        getYearData() {
            let params = {};
            if (!this.curPointId) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            this.tableLoading = true;
            params = {
                tree_unit_id: this.curPointId,
                show_day: this.formatShowDay()
            };
            api.getYearDataForReport(params).then(res => {
                if (res && res.error_code === "0") {
                    this.xAxis = [];
                    this.yAxis = [];
                    if (res.bus_json.length) {
                        res.bus_json.forEach(item => {
                            item.name = this.pointName;
                            this.xAxis.push(item.show_day);
                            this.yAxis.push(item.active_power);
                        });
                    }
                    this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            });
            this.tableHLoading = true;
            api.getYearDataCollection(params).then(res => {
                if (res && res.error_code === "0") {
                    this.xHAxis = [];
                    this.yHAxis = [];
                    if (res.bus_json.powerReportList.length) {
                        res.bus_json.powerReportList.forEach(item => {
                            item.name = this.pointName;
                            this.xHAxis.push(item.show_day);
                            this.yHAxis.push(item.active_power);
                        });
                    }
                    this.sum_active_power = res.bus_json.sum_active_power;
                    this.tableHData = res.bus_json.powerReportList;
                }
                this.tableHLoading = false;
            });
        },
        formatShowDay() {
            let show_day = "";
            if (this.tabVal === "day" || this.tabVal === "port") {
                show_day = dayjs(new Date(this.time)).format("YYYY-MM-DD");
            } else if (this.tabVal === "month") {
                show_day = dayjs(new Date(this.time)).format("YYYY-MM");
            } else {
                show_day = dayjs(new Date(this.time)).format("YYYY");
            }
            return show_day;
        },
        /**
         * 下一日、下一月、下一年点击
         */
        nextTimeClick() {
            let todayD = new Date(this.todayD).getTime();
            let todayM = new Date(this.todayM).getTime();
            let todayY = new Date(this.todayY).getTime();
            if (this.tabVal === "day" || this.tabVal === "port") {
                this.time = dayjs(new Date(this.time))
                    .add(1, "days")
                    .format("YYYY-MM-DD");
            } else if (this.tabVal === "month") {
                this.time = dayjs(new Date(this.time))
                    .add(1, "months")
                    .format("YYYY-MM");
            } else {
                this.time = dayjs(new Date(this.time))
                    .add(1, "years")
                    .format("YYYY");
            }
            // 获取报告列表
            this.handleSearchReport();
            let selectTime = new Date(this.time).getTime();
            if (
                ((this.tabVal === "day" || this.tabVal === "port") &&
                    selectTime >= todayD) ||
                (this.tabVal === "month" && selectTime >= todayM) ||
                (this.tabVal === "year" && selectTime >= todayY)
            ) {
                this.nextTimeDisabled = true;
            } else {
                this.nextTimeDisabled = false;
            }
        },
        handleExportExl() {
            let type = 1;
            if (this.isKW && this.tabVal == "month") type = 2;
            if (this.isKW && this.tabVal == "year") type = 3;
            if (!this.isKW && this.tabVal == "day") type = 4;
            if (!this.isKW && this.tabVal == "month") type = 5;
            if (!this.isKW && this.tabVal == "year") type = 6;
            api.getPowerReportExcel({
                tree_unit_id: this.curPointId,
                show_day: this.formatShowDay(),
                type: type
            }).then(res => {
                const content = res;
                const blob = new Blob([content]);
                const fileName = this.isKW ? "功率统计.xlsx" : "电量统计.xlsx";
                if ("download" in document.createElement("a")) {
                    const elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                } else {
                    navigator.msSaveBlob(blob, fileName);
                }
            });
        }
    },
    computed: {
        lineBar() {
            const options = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        label: {
                            backgroundColor: "#6a7985"
                        }
                    }
                },
                legend: {},
                grid: {
                    left: "5%",
                    right: "4%",
                    top: "10%",
                    bottom: "10%",
                    containLabel: true
                },
                xAxis: [
                    {
                        name:
                            this.tabVal == "day"
                                ? "时"
                                : this.tabVal == "month"
                                ? "日"
                                : "月",
                        type: "category",
                        boundaryGap: false,
                        axisLine: {
                            lineStyle: {
                                color: "#999999"
                            }
                        },
                        data: this.xAxis
                    }
                ],
                yAxis: [
                    {
                        name: "kW",
                        type: "value",
                        axisLine: {
                            lineStyle: {
                                color: "#999999"
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: "solid",
                                color: ["#0f429f"]
                            }
                        }
                    }
                ],
                series: [
                    {
                        type: "line",
                        //  stack: "总量",
                        label: {
                            normal: {
                                show: false,
                                position: "top"
                            }
                        },
                        itemStyle: {
                            color: "#13C2F0"
                        },
                        smooth: true,
                        symbol: "none",
                        data: this.yAxis
                    }
                ]
            };
            return options;
        },
        lineHBar() {
            const options = {
                color: "#13C2F0",
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: "5%",
                    right: "4%",
                    top: "10%",
                    bottom: "10%",
                    containLabel: true
                },
                xAxis: [
                    {
                        name:
                            this.tabVal == "day"
                                ? "时"
                                : this.tabVal == "month"
                                ? "日"
                                : "月",
                        type: "category",
                        // boundaryGap: false,
                        axisLine: {
                            lineStyle: {
                                color: "#999999"
                            }
                        },
                        axisTick: {
                            alignWithLabel: true
                        },
                        data: this.xHAxis
                    }
                ],
                yAxis: [
                    {
                        name: "kW·h",
                        type: "value",
                        axisLine: {
                            lineStyle: {
                                color: "#999999"
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: "solid",
                                color: ["#0f429f"]
                            }
                        }
                    }
                ],
                series: [
                    {
                        type: "bar",
                        name: "电量",
                        barMaxWidth: 30,
                        data: this.yHAxis
                    }
                ]
            };
            return options;
        }
    }
};
</script>
<style lang="scss">
.table_with_container {
    height: calc(100% - 55px);
    .leader-title {
        color: #fff;
    }
    .search_cont {
        width: 100%;
        margin: 15px 0 20px 0;
        .form {
            display: flex;
            justify-content: space-between;
            .button-group {
                display: inline-block;
                margin-left: 20px;
                // button {
                //     background: rgb(41, 184, 94);
                //     color: white;
                //     outline: none;
                //     border-color: rgb(41, 184, 94);
                // }
                .el-button.is-disabled,
                .el-button.is-disabled:focus,
                .el-button.is-disabled:hover {
                    border-color: #ebeef5;
                }
            }
            // .el-input__inner {
            //     height: 36px;
            //     line-height: 36px;
            // }
        }
    }
    .table_cont-wrap {
        width: 100%;
        height: calc(100% - 55px - 46px - 35px);
        padding: 0;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
        .green {
            height: 12px;
            width: 5px;
            background: #0089f1;
            margin: 10px;
            float: left;
        }
        .table_change_btn {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%, 0);
        }
        width: 100%;
        font-size: 16px;
        text-align: left;
        line-height: 32px;
    }
    .table-wrap-n {
        width: 100%;
        height: calc(100% - 62px);
        // overflow: auto;
        // font-size: 14px;
        font-size: 14px;
        width: 100%;
        padding: 30px 30px 0 30px;
        box-sizing: border-box;
        // height: 500px;
        margin: 0;
        position: relative;
        /*background: url("../../../../../assets/image/leaderpage/table-bg.png")*/
        /*    no-repeat;*/
        background-size: 100% 100%;
        overflow: auto;
        .echarts {
            width: 100%;
            height: 100%;
        }
        .table-header {
            width: 100%;
            display: flex;
            flex-direction: row;

            color: #fff;
            height: 50px;
            line-height: 50px;
            // border-top: 1px solid #ededed;
            // border-left: 1px solid #ededee;
        }
        .table-name {
            min-width: 200px !important;
            box-sizing: border-box;
        }
        .table-header-colum {
            flex: 1;
            // border-right: 1px solid #ededed;
            // border-bottom: 1px solid #ededed;
            // background: #f8f8f8;
            background: rgba(38, 77, 132, 0.6) !important;
            text-align: center;
            min-width: 80px;
            padding: 3px 0;
        }
        .table-row {
            display: flex;
            flex-direction: row;
            min-width: 100%;
            color: #fff;

            // border-left: 1px solid #ededee;
            .table-row-item {
                flex: 1;
                // border-right: 1px solid #ededed;
                // border-bottom: 1px solid #ededed;
                text-align: center;
                min-width: 80px;
                // padding: 3.5px 0;
            }
        }
        .table-row:nth-child(2n) .table-row-item {
            background: transparent !important;
            color: #ffffff;
            height: 50px;
            line-height: 50px;
        }

        .table-row:nth-child(2n + 1) .table-row-item {
            background: rgba(38, 77, 132, 0.6) !important;
            color: #ffffff;
            height: 50px;
            line-height: 50px;
        }
        .table-nodata {
            // border: 1px solid #ededed;
            text-align: center;
            // color: #999;
            color: #fff;
        }
    }
}
</style>
